import { IConfigsType } from '../../types'

const burgerworksOriginalCorporatePagesConfig: IConfigsType = {
  burgerworks: {
    '/:brand/corporate_product': {},
  },
}

export default burgerworksOriginalCorporatePagesConfig
